import { render } from "./tokenPRSection.vue?vue&type=template&id=0057ba05"
import script from "./tokenPRSection.vue?vue&type=script&lang=js"
export * from "./tokenPRSection.vue?vue&type=script&lang=js"

import "./tokenPRSection.vue?vue&type=style&index=0&id=0057ba05&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__